import React from "react";

const ContactUsform = () => {
  return (
    <div
      className="w-full max-w-md p-10 rounded-3xl shadow-2xl border border-white/30"
      style={{
        background: "rgba(255, 255, 255, 0.75)",
        backdropFilter: "blur(15px)",
      }}
    >
      <h2 className="text-3xl font-bold text-center text-[#3b4cca] mb-8">
        Contact Information
      </h2>

      {/* Email */}
      <div className="mb-6">
        <h4 className="text-gray-800 font-semibold mb-2">📧 Email</h4>
        <a
          href="mailto:admissions@sriramanujar.ac.in"
          className="text-blue-600 hover:text-blue-800 transition duration-300 no-underline"
        >
          admissions@sriramanujar.ac.in
        </a>
      </div>

      {/* Phone */}
     <div className="space-y-2 text-gray-700">

  <div>
    Principal:{" "}
    <a href="tel:+919444859455" className="text-blue-600 no-underline">
      +91 94448 59455
    </a>
  </div>

  <div>
    Manager:{" "}
    <a href="tel:+919840832639" className="text-blue-600 no-underline">
      +91 98408 32639
    </a>
  </div>

  <div>
    Office:{" "}
    <a href="tel:+914422751380" className="text-blue-600 no-underline">
      044 – 22751380
    </a>
  </div>

</div>

      {/* Address */}
      <div className="mt-5">
        <h4 className="text-gray-800 font-semibold mb-2">📍 Address</h4>
        <p className="text-gray-600 leading-relaxed">
          Kolapakkam, Vandalur,
          <br />
          Chennai, Tamil Nadu,
          <br />
          India – 600127
        </p>
      </div>
    </div>
  );
};

export default ContactUsform;